var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Grid',{ref:"filterGridBrand",attrs:{"name":"filterGridBrand","url":_vm.url,"columns":_vm.columns,"pageable":false,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f109452","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Filters/BrandFilter.vue
// module id = 915
// module chunks = 1